import { render, staticRenderFns } from "./HotBook_phone.vue?vue&type=template&id=c39eabce&scoped=true"
import script from "./HotBook_phone.vue?vue&type=script&lang=js"
export * from "./HotBook_phone.vue?vue&type=script&lang=js"
import style0 from "./HotBook_phone.vue?vue&type=style&index=0&id=c39eabce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39eabce",
  null
  
)

export default component.exports